import { render, staticRenderFns } from "./Gold.vue?vue&type=template&id=097a5368&scoped=true"
import script from "./Gold.vue?vue&type=script&lang=js"
export * from "./Gold.vue?vue&type=script&lang=js"
import style0 from "./Gold.vue?vue&type=style&index=0&id=097a5368&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097a5368",
  null
  
)

export default component.exports